import React, { useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import Contact from "../components/Contact";
import icon from "../assets/images/icona.png";
import Section from "./Section";
import Preloader from "../components/Preloader";
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import FooterAlt from '../Layout/FooterAlt';

const ServicesCard = (props) => {
  return (
    <>
      <Col lg={6} md={6} className="mt-5 align-items-stretch">
        <div
          className={
            props.isShadow
              ? "service-box text-center mt-40 box-shadow hover-effect h-100"
              : "service-box text-center mt-40 h-100"
          }
          style={{cursor:"pointer"}}
          onClick={props.onClick}
        >
          <Row className="align-items-center justify-content-center">
            <Col lg={2} md={2} className="p-0">
              <img src={props.imgsrc} alt="" className="img-fluid" />
            </Col>
            <Col lg={4} md={4} className="p-0">
            <h1 className="text-dark m-0 fs-1">
                  {" "}
                  <span className="red-text">{props.title[0]}</span>{props.title.slice(1,props.title.lenght)}
                </h1>
              {/* <h5 className="fs-18 mt-4">{props.title}</h5> */}
              </Col>
          </Row>
          <div className="lighlight-border mt-4"></div>
          <p className="text-primary mt-3 fs-2">{props.caption}</p>
        </div>
      </Col>
      {/* <!--end col--> */}
    </>
  );
}

// Services data

const ServicesData = [
    
  {
    imgsrc: icon,
    title: "Noleggio",
    caption:
      "Tenergia s.r.l. offre la possibilità di noleggiare i suoi Gruppi elettrogeni e Torri faro con forme di locazione vantaggiose e personalizzate a breve e a lungo termine. La vasta scelta tra i nostri prodotti, rende questo tipo di soluzione adatta a diversi tipi di esigenze come lavorazioni edili, aziende agricole, impianti fotovoltaici, condomini, ristoranti, attività commerciali di ogni genere, feste private, eventi sportivi o emergenze di ogni tipo come blackout o allagamenti.",
    isShadow: true,
  },
  {
    imgsrc: icon,
    title: "Vendita",
    caption:
      "Tenergia s.r.l. offre ai suoi clienti una vastissima gamma di Gruppi elettrogeni, Torri faro e UPS Gruppi di continuità nuovi in pronta consegna o su ordinazione, scelti tra le migliori marche presenti sul mercato mondiale come Pramac, Mahindra e Mosa. Tenergia s.r.l. inoltre dispone, per chi vuole risparmiare in assoluta sicurezza, di un parco Usato revisionato in sede e garantito 12 mesi.",
      isShadow: true,
    },
  {
    imgsrc: icon,
    title: "Assistenza",
    caption:
      "Assistenza tecnica 24 ore su 24. Controlli in prima attivazione. Ricerca e Soluzione anomalie o guasti, messe a punto e controlli funzionali. Verifiche occasionali e periodiche. Pratiche U.T.F. e loro applicazioni, defiscalizzazione combustibile. Manutenzioni elettromeccaniche impianti elettrici, civili e industriali. Consulenze energetiche con sistemi di monitoraggio a distanza. Sicurezza sul lavoro secondo quanto previsto dal D.Legs. 81/08, s.m.i. e Cooperazione e Coordinamento previsto dall’art. 26.",
    isShadow: true,
    },
  {
    imgsrc: icon,
    title: "Ricambi",
    caption:
      "Disponiamo per chiunque lo necessiti, una vastissima gamma di ricambi  sia pronta consegna che su ordinazione.",
      isShadow: true,
    }
];

const Services = () => {
  const navigate = useNavigate()
  const goToService = (title,isShadow) => {
    if (isShadow){
      navigate(`/servizi/${title}`)
    }
  }
  return (
    <>
      <Section leftSide={"Servizi"}/>
        <section className="section background-white" id="services-img">
          <Container>
          <Row className="justify-content-center">
            <Col lg={7}> 
              <div className="header-title text-center text-dark">
                <div className="title-border mt-3"></div>
              </div>
            </Col>
          </Row>

          <Row>
            {/* Services Component Start */}

            {ServicesData.map((value, idx) => (
              <ServicesCard
                key={idx}
                imgsrc={value.imgsrc}
                title={value.title}
                caption={value.caption}
                isShadow={value.isShadow}
                onClick={() => goToService(value.title,value.isShadow)}
              />
            ))}

            {/* Services Component End */}
          </Row>
        </Container>
      </section>

    </>
  );
}

const ServiziMain = () =>{
    return ( <React.Fragment>
      <Preloader />
      <Navbar />
        <Services />
        <Contact />
        <Footer />
        <FooterAlt />
    </React.Fragment>)
}

export default ServiziMain;